import React, { useCallback } from 'react';
import { emitEvent } from '@/services/EventService';
import { logoutUser } from '@/services/typo3api/auth.web';
import { useFocusEffect } from 'expo-router';

export default function Logout() {

  useFocusEffect(
    useCallback(() => {
      const handleLogout = async () => {
        await logoutUser(); 
        emitEvent('LogoutEvent', null);
      };
  
      handleLogout(); 
    }, [])
  );
  
  return (
    <></>
  );
}